import { render, staticRenderFns } from "./RaidPage.vue?vue&type=template&id=3967e24e&scoped=true&"
import script from "./RaidPage.vue?vue&type=script&lang=ts&"
export * from "./RaidPage.vue?vue&type=script&lang=ts&"
import style0 from "./RaidPage.vue?vue&type=style&index=0&id=3967e24e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967e24e",
  null
  
)

export default component.exports